import React from "react"
import {BackgroundContainer} from "./component"

export const StandardBackgroundContainer = ({children}) => {
    return <BackgroundContainer>{children}</BackgroundContainer>
}

export default StandardBackgroundContainer
